import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import AuthContextProvider from './Context/AuthContext'
import AppEntry from './AppEntry/AppEntry'
import ClassContextProvider from './Context/ClassContext'
import BatchContextProvider from './Context/BatchContext'
import DemoContextProvider from './Context/DemoContext'
import PaymentContextProvider from './Context/PaymentContext'
import { DialogProvider } from './Context/DialogContext'
import { GetAppDialogProvider } from './Context/GetAppDialogContext'

const App = () => {
  if (import.meta.env.VITE_NODE_ENV !== 'develop') {
    console.log = function no_console() {}
    console.error = function no_console_error() {}
    console.debug = function no_console_debug() {}
  }

  useEffect(() => {
    const token = import.meta.env.VITE_CHATWOOT_TOKEN
    if (!token) {
      console.error('CHATWOOT_TOKEN is not set!')
      return
    }
    const script = document.createElement('script')
    script.src = 'https://support.edvi.app/packs/js/sdk.js'
    script.async = true
    script.defer = true
    script.onload = () => {
      window.chatwootSDK.run({
        websiteToken: token,
        baseUrl: 'https://support.edvi.app',
      })
    }
    document.body.appendChild(script)
  }, [])

  return (
    <div className="edvi-app-root">
      <AuthContextProvider>
        <ClassContextProvider>
          <BatchContextProvider>
            <PaymentContextProvider>
              <DemoContextProvider>
                <Router>
                  <DialogProvider>
                    <GetAppDialogProvider>
                      <AppEntry />
                    </GetAppDialogProvider>
                  </DialogProvider>
                </Router>
              </DemoContextProvider>
            </PaymentContextProvider>
          </BatchContextProvider>
        </ClassContextProvider>
      </AuthContextProvider>
    </div>
  )
}

export default App
